import React from "react";
import { BsFillBasket3Fill } from "react-icons/bs";

const OrderItems = ({ order }) => (
  <div className="mt-8">
    <div className="flex items-center">
      <BsFillBasket3Fill size={30} color="crimson" />
      <h1 className="pl-3 text-2xl font-semibold text-gray-800">Order Items</h1>
    </div>
    <div className="overflow-x-auto mt-4">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-cyan-100">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {order.cart.map((item) => (
            <tr key={item._id}>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-10 w-10">
                    <img
                      className="h-10 w-10 rounded-full"
                      src={item.images[0].url || "/placeholder.svg"}
                      alt={item.name}
                    />
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-gray-900">{item.name}</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.qty}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">${item.discountPrice.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="mt-8 text-right">
      <p className="text-xl font-semibold text-gray-800">Total: ${order.totalPrice.toFixed(2)}</p>
    </div>
  </div>
)

export default OrderItems

